<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you ever had ANY of the following procedures to fix for a blocked neck artery?<br /><i>(Check all that apply)</i>
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.procedures">
      <b-form-checkbox v-model="survey.arteryBlockages.blockedNeckArteryProcedures.hadNoSurgery"
                       @change="onNoSurgerySelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedNeckArteryProcedures.hadSurgery"
                       @change="onSurgerySelected">
        Surgery for a blocked neck artery
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockedNeckArteryProcedures.hadStent"
                       @change="onStentSelected">
        Stent of a blocked neck artery
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      procedures: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoSurgery || value.hadSurgery || value.hadBlockageSurgery
          || value.hadStent)
      }
    },

    computed: {
      ...mapState(["survey"]),

      procedures() { return this.survey.arteryBlockages.blockedNeckArteryProcedures; }
    },

    methods: {
      onNoSurgerySelected(value) {
        this.setOptions(value, false, false);
      },

      onSurgerySelected(value) {
        this.setOptions(false, value, this.procedures.hadStent);
      },

      onStentSelected(value) {
        this.setOptions(false, this.procedures.hadSurgery, value);
      },

      setOptions(hadNoSurgery, hadSurgery, hadStent) {
        this.survey.arteryBlockages.blockedNeckArteryProcedures.hadNoSurgery = hadNoSurgery;
        this.survey.arteryBlockages.blockedNeckArteryProcedures.hadSurgery = hadSurgery;
        this.survey.arteryBlockages.blockedNeckArteryProcedures.hadStent = hadStent;
      }
    }
  };
</script>